var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAppointmentsPressed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_appointments copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 24 0 24 25.0449486 0 25.0449486"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_appointments-copy",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8771161,2.26208319 L18.8771161,1.00850788 C18.8771161,0.451139194 18.4256408,0 17.8686082,0 C17.3115757,0 16.8601003,0.451139194 16.8601003,1.00850788 L16.8601003,5.91590725 C16.8601003,6.47293977 17.3115757,6.92441514 17.8686082,6.92441514 C18.4256408,6.92441514 18.8771161,6.47293977 18.8771161,5.91590725 L18.8771161,4.27909895 L21.0588548,4.27909895 C21.5684875,4.27909895 21.9829842,4.69359569 21.9829842,5.20322835 L21.9829842,22.1038035 C21.9829842,22.6134361 21.5684875,23.0279329 21.0588548,23.0279329 L2.94101069,23.0279329 C2.43137804,23.0279329 2.0168813,22.6134361 2.0168813,22.1038035 L2.0168813,5.20322835 C2.0168813,4.69359569 2.43137804,4.27909895 2.94101069,4.27909895 L4.90592022,4.27909895 L4.90592022,5.91590725 C4.90592022,6.47293977 5.35739558,6.92441514 5.91442811,6.92441514 C6.47146063,6.92441514 6.92293599,6.47293977 6.92293599,5.91590725 L6.92293599,4.27909895 L14.0890568,4.27909895 C14.6460894,4.27909895 15.0975647,3.82762359 15.0975647,3.27059107 C15.0975647,2.71355855 14.6460894,2.26208319 14.0890568,2.26208319 L6.92293599,2.26208319 L6.92293599,1.00850788 C6.92293599,0.451139194 6.47146063,0 5.91442811,0 C5.35739558,0 4.90592022,0.451139194 4.90592022,1.00850788 L4.90592022,2.26208319 L2.94101069,2.26208319 C1.31933001,2.26208319 -0.000134467718,3.58154767 -0.000134467718,5.20322835 L-0.000134467718,22.1038035 C-0.000134467718,23.7258203 1.31933001,25.0449486 2.94101069,25.0449486 L21.0588548,25.0449486 C22.6805355,25.0449486 24,23.7258203 24,22.1038035 L24,5.20322835 C24,3.58154767 22.6805355,2.26208319 21.0588548,2.26208319 L18.8771161,2.26208319 Z",
    id: "Fill-1",
    fill: "#172B4E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#172B4E",
    strokeWidth: 2,
    strokeLinejoin: "round",
    x: 12,
    y: 12.9230769,
    width: 6.46153846,
    height: 6.46153846
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppointmentsPressed);
export default __webpack_public_path__ + "static/media/icon_appointments_pressed.15b6a3af6a391363828ad7b77d08e346.svg";
export { ForwardRef as ReactComponent };